import { AppClockService, DateTimeService } from '@mews/framework';

/**
 * @param params
 * @param params.appClockService - use appClockService from thunk or React context
 * @param params.timezone - use result of getCurrentEnterpriseIanaTimeZoneIdentifier selector
 */
export const getAppDateTimeNow = ({
    appClockService,
    timezone,
}: {
    appClockService: AppClockService;
    timezone: string;
}) => DateTimeService.fromUtc(appClockService.getAppNowUtc(), timezone);
